module.exports = __webpack_public_path__ + "img/TechCaravan1_ua.56924996.webp";